<template>
  <div class="card additional-info">
    <div class="promotion-block">
      <h2>
        Полезные материалы
      </h2>
      <p>
        Вы сделали первый шаг на пути к тому, чтобы стать продвинутым пользователем эмоционального интеллекта. Не останавливайтесь на достигнутом — развивайте эмоциональный интеллект вместе с нами:
      </p>

      <div class="cards-list">
        <template v-for="(card, index) in cardObject" :key="index">
          <a-card @click="openLink(card.link)" class="link-card">
            <template #cover>
              <img :src="card.image" class="promo-card-image" alt="Изображение">
            </template>
            <div class="link-card-content">
              <a :href="card.link" target="_blank" class="link">
                {{ card.name }}
              </a>
              <p>
                {{ card.description }}
              </p>
            </div>
          </a-card>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import Pic1 from '@/assets/images/additional/add_1.png';
  import Pic2 from '@/assets/images/additional/add_2.png';
  import Pic3 from '@/assets/images/additional/add_3.png';

  export default {
    setup() {
      const cardObject = [
        {
          name: 'Научная методика тестирования ЭИ',
          description: 'Узнайте, как работает наша система оценки.',
          image: Pic1,
          link: 'https://way2wei.ru/methodology',
        },
        {
          name: 'Рассказы по ЭИ',
          description: 'Серия художественных эпизодов, которые на ярких жизненных примерах раскрывают природу эмоций и их влияние на наши решения.',
          image: Pic2,
          link: 'https://way2wei.ru/register/stati/1',
        },
        {
          name: 'Медиа-центр',
          description: 'Большая библиотека знаний об эмоциональном интеллекте: экспертные статьи, последние новости СМИ и подкасты.',
          image: Pic3,
          link: 'https://way2wei.ru/media-center',
        }
      ];

      const openLink = (link) => {
        window.open(link, '_blank');
      }

      return {
        cardObject,
        openLink
      }
    }
  }
</script>

<style scoped lang="scss">
  .additional-info {
    padding: 20px;
  }

  h2 {
    font-size: 16px;
  }

  p {
    font-size: 14px;
  }

  .cards-list {
    margin-top: 25px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 16px;

    @media (max-width: $tablet-breakpoint) {
      display: flex;
      flex-wrap: wrap;
    }
  }

  .link-card {
    width: 256px;
    height: 350px;
    cursor: pointer;

    &:hover {
      border-color: var(--main-green);
    }

    .link-card-content {
      display: flex;
      flex-direction: column;
      row-gap: 10px;
    }

    @media (max-width: $mobile-breakpoint) {
      width: 100%;
    }
  }

  .link {
    font-weight: 600;
    font-size: 14px;
  }

  .promotion-block {
    max-width: 800px;
  }

  .promo-card-image {
    object-fit: cover;
    max-height: 200px;
  }
</style>